import { useMemo } from 'react'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { useData } from '@/contexts/data'

interface PostContextsProps {
  contextIds: string[]
}

export function PostContexts({ contextIds }: PostContextsProps) {
  const { contexts } = useData()
  const idToName = useMemo(() => {
    const map = new Map<string, string>()
    contexts.forEach((c) => map.set(c.id, c.name))
    return map
  }, [contexts])
  const contextNames = useMemo(
    () => (contextIds.length === 0 ? [] : contextIds.map((id) => idToName.get(id)).filter(Boolean) as string[]),
    [contextIds, idToName]
  )

  if (contextNames.length === 0) {
    return null
  }

  const firstContext = contextNames[0]
  const remainingCount = contextNames.length - 1
  const allContextsText = contextNames.join(', ')

  return (
    <div className="flex items-center gap-2">
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="flex items-center gap-2">
              <div className="bg-blue-600 text-white px-2 py-0.5 rounded-full text-xs">
                {firstContext}
              </div>
              {remainingCount > 0 && (
                <div className="bg-blue-600 text-white px-2 py-0.5 rounded-full text-xs">
                  +{remainingCount}
                </div>
              )}
            </div>
          </TooltipTrigger>
          <TooltipContent
            side="bottom"
            className="!bg-blue-600 !text-white border-blue-600 rounded-lg py-1.5 px-3"
          >
            <p>{allContextsText}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  )
}
